import { useT } from 'talkr';
import img1 from './img/img1.png';
import img2 from './img/img2.png';
import img3 from './img/img3.png';
import img4 from './img/img4.png';
import img5 from './img/img5.png';
import img6 from './img/img6.png';

interface IData {
	name: string;
	text: string;
	img: string;
}

export const useData = (): IData[] => {
	const { T } = useT();

	return [
		{
			name: 'Sarah Johnson',
			text: 'This program was a game-changer! I lost 10 pounds in just two weeks, and I finally feel confident in my body.',
			img: img1,
		},
		{
			name: 'Michael Thompson',
			text: 'I can\'t believe how effective the weight loss program was for me. I shed 15 pounds in a month and gained so much energy and self-esteem.',
			img: img2,
		},
		{
			name: 'Emily Davis',
			text: 'It completely transformed my lifestyle and made me feel amazing.',
			img: img3,
		},
		{
			name: 'John Anderson',
			text: 'This program exceeded my expectations! In just six weeks, I managed to lose 12 pounds and develop healthy habits that will last a lifetime.',
			img: img4,
		},
		{
			name: 'Jennifer Smith',
			text: 'I\'m so grateful for the weight loss program, I finally feel like I have control over my eating habits.',
			img: img5,
		},
		{
			name: 'Juan Martinez',
			text: 'It worked wonders for me! I dropped 25 pounds in four months, and I can\'t believe how much healthier and happier I am now.',
			img: img6,
		},
	];
};
